import { ContractCustomerRefPendenciesModel, ContractCustomerRefLegalRepresentativePendenciesModel } from '~/graphql/types'

/**
 * Verifica se um campo específico do cliente do contrato possui pendência
 * @param fieldName - Nome do campo a ser verificado
 * @param pendencies - Objeto com as pendências do cliente do contrato
 * @returns true se o campo possui pendência (rejeitado e não aceito), false caso contrário
 */
export const isContractPendencyField = (fieldName: keyof ContractCustomerRefPendenciesModel, pendencies?: ContractCustomerRefPendenciesModel | null) => {
  if (!pendencies) {
    return false
  }

  const pendencyFields = Object.entries(pendencies).filter(pendency => pendency[1]?.rejectedAt && !pendency[1]?.acceptedAt).map(pendency => pendency[0])

  return pendencyFields.includes(fieldName)
}

/**
 * Verifica se um campo específico do representante legal do contrato possui pendência
 * @param fieldName - Nome do campo a ser verificado
 * @param pendencies - Objeto com as pendências do representante legal do contrato
 * @returns true se o campo possui pendência (rejeitado e não aceito), false caso contrário
 */
export const isContractLegalRepresentativePendencyField = (fieldName: keyof ContractCustomerRefLegalRepresentativePendenciesModel, pendencies?: ContractCustomerRefLegalRepresentativePendenciesModel | null) => {
  if (!pendencies) {
    return false
  }

  const pendencyFields = Object.entries(pendencies).filter(pendency => pendency[1].rejectedAt && !pendency[1].acceptedAt).map(pendency => pendency[0])

  return pendencyFields.includes(fieldName)
}
